import styled from "styled-components"

export const StyledDocumentPage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    padding: 1.5rem 0 3.5rem;
`
